var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.UserSystem.appleUser())?_c('carousel',{attrs:{"autoplay":!_vm.noAutoplay,"autoplayTimeout":_vm.autoplayTimeout,"loop":!_vm.noLoop,"nav":_vm.showNav,"dots":_vm.showDots,"margin":_vm.getMargin,"autoWidth":!_vm.noAutoWidth}},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }